
import ModuleManager from "../../../../../../framework/core/module_manager";
import { JdSeatModel } from "./jd_seat_model";
import { JdSeatView } from "./jd_seat_view";
import { JdTableEntityBase } from "../table/jd_table_entity_base";
import { JdTableData } from "../../data/jd_table_data";
import { JdHelp } from "../../help/jd_help";
import { JdConst } from "../../data/jd_define";
import UserDataManager from "../../../../../../manager/user_manager";
import JdSound from "../../../jd_sound";
import { JdPokerComponent } from "../../component/jd_poker_component";
import { JdSeatConfig } from "../../component/jd_seat_state_component";
import { IUserData } from "../../../../../public/model_data";
import { Jd } from "../../../../net/proto/proto_jd_game";
import { CountUp } from "../../../../../../lib/countUp";
import TexasSound from "../../../../../texasholdem/module/texas_sound";
import AppData from "../../../../../public/const/app_data";
import { PokerCommonColor } from "../../../../../k9/module/table/component/poker_com_color";
import Utility from "../../../../../../utility/utility";

//实体座位(管理model,view)
export class JdSeatEntity extends cc.EventTarget{

    protected modelBase:JdSeatModel;

    protected viewBase:JdSeatView;

    beloneTable:JdTableEntityBase;

    //用于牌型的座位排序
    sortID:number;

    //服务器座位ID
    private _serverSeatID:number;

    isSeat:boolean;//是否坐下

    is_allin:boolean = false;

    operatorFunc:Function;

    protected stateFunc:{[k:number]:Function} = {};

    get serverSeatID() {
        return this._serverSeatID;
    }

    get playerID(){
        let data = this.modelBase.seatPlayerData
        if (data) {
            return data.player_id;
        }
        return null;
    }

    set serverSeatID(v:number){
        this._serverSeatID = v;
    }

    get isMySelf():boolean{//可以能弃牌
        if (this.seatData) {
            return this.beloneTable.isRole(this.seatData.player_id);
        }
        return false;
    }

    get seatData():JdTableData.SeatPlayerData{
        return this.modelBase.seatPlayerData;
    }

    set seatData(v:JdTableData.SeatPlayerData){
        this.modelBase.seatPlayerData = v;
    }

    get playerHands():PokerCommonColor[]{
        return this.viewBase.playerHands;
    }

    //筹码结束位置
    get betEndNode():cc.Node{
        return this.viewBase.betEndNode;
    }

    get effectNode():cc.Node{
        return this.viewBase.effectNode;
    }

    Init(seatParent:cc.Node,beloneTable:JdTableEntityBase){
        this.beloneTable = beloneTable;
        this.baseModelInstance();
        this.baseViewInstance(seatParent);
        this.onInit();
    }

    
    baseModelInstance(){
        if (!this.modelBase) {
            this.modelBase = new JdSeatModel();
            this.modelBase.Init();
        }
    }

    baseViewInstance(parent:cc.Node){
        if (!this.viewBase) {
            this.viewBase = new JdSeatView();
            this.viewBase.seatNode = JdHelp.AddChild(this.beloneTable.seatInfoPrefab,parent);
            this.viewBase.Init();
        }
    }
    onInit(){
        this.setActiveInfo(false);
        this.setSmallCard(false);
        this.setBetState(false);
        this.registerOperator();
    };

    showChat(){
        let node = this.beloneTable.chatNode;
        if (this.seatData) {
            ModuleManager.instance.showEmojiModule(this.seatData.player_id,'JdPokerTable')
        }
    }

    getSeatNode():cc.Node{
        return this.viewBase.seatNode;
    }

    //设置信息显示
    setActiveInfo(isShow:boolean){
        this.viewBase.inforNode.active = isShow;
    }

    hideCheckGold(){
        this.setBetState(false);
        this.viewBase.recycleCheckBet();
    }

    //设置金币的显示
    setBetState(isShow:boolean){
        this.viewBase.setBet(isShow);
    }

    updateEntityChips(oldChips:number){
        let data = this.seatData;
        if (data) {
            let chouma = new CountUp(null,data.coin_balance,{
                startVal: oldChips,
                decimalPlaces: 2,
                duration: 0.5,
                useEasing: false,
                useGrouping: false,
                smartEasingThreshold: 999,
                smartEasingAmount: 333,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            })
            if(!chouma.error){
                chouma.start((n)=>{
                    if (this.viewBase && this.viewBase.isNoDestroy) {
                        this.updateChips(Number(n));
                    }
                })
            }

            this.viewBase.playGrades(true,data.coin_balance - oldChips);
        }
    }

    //检查归池
    checkIsGuiChi(){
        let data = this.seatData;
        if (data) {
            return data.bet > 0;
        }
        return false;
    }

    getPosition():cc.Vec2{
        return this.viewBase.seatNode.position;
    }

    setMask(isShow:boolean){
        let avatar = this.getAvatar();
        if (avatar) {
            avatar.showMask(isShow);
        }
    }

    setPosition(pos:cc.Vec2){
        this.viewBase.seatNode.position = pos;
    }

    //是否在游戏中
    isPlayingGame(){
        if (this.seatData) {
            if (this.seatData.state != 0
                && this.seatData.state != 8) {
                return true;
            }
        }
        return false;
    }

    stopAllActions(){
        this.viewBase.seatNode.stopAllActions();
    }

    setServerIndex(index:number){
        this.viewBase.setServerIndex(index);
    }

    setServerActive(isShow:boolean){
        this.viewBase.setServerActive(isShow);
    }

    //是否弃牌
    isFold(){
        if (this.seatData) {
            return this.seatData.state == JdConst.SeatState.fold;
        }
        return true;
    }

    //设置操作描述
    setOperatorDes(value:string,operator:JdConst.OperatorType){
        if (value) {
            this.viewBase.setOperatorDes(value,operator);
        }
    }

    //重置手牌
    resumeHands(cards:number[]){
        this.viewBase.resumeHands(cards);
    }

    showSmallCards(){
        if (this.seatData) {
            this.viewBase.showSmallCards(this.seatData.cards);
        }
    }

    //准备发牌设置显示 haveCards 已经拥有的
    beginDealCards(haveCards:number){
        this.viewBase.beginDealCards(haveCards,this.isMySelf);
    }

    //发牌
    dealCards(s:cc.Node,index:number){
        if (this.seatData) {
            this.viewBase.dealCards(s,index,this.seatData.cards);
        }
    }

    //弃牌
    throwCardsAction(source:cc.Node){
        if (this.seatData) {
            this.viewBase.throwCardsAction(source,this.seatData.cards.length);
        }
    }

    throwCard(){
        if (!this.isMySelf) {
            this.setSmallCard(true);
            this.throwCardsAction(this.beloneTable.dealerNode);
        }
    }

    checkBetAction(goldNumb:number,func?:Function){
        if (goldNumb > 0) {
            this.setBetNumb(goldNumb);
            this.viewBase.checkBetAction(goldNumb,func);
        }
    }

    //归池
    guiChi(target:cc.Node,func?:Function){
        this.viewBase.guiChi(target,func);
    }
    //直接显示下注额
    showBet(gold:number){
        this.setBetNumb(gold);
        this.viewBase.showBet(gold);
    }

    //获得bet
    obtainBet(target:cc.Node,gold?:number,func?:Function){
        this.viewBase.obtainBet(target,gold,()=>{
            this.viewBase.flyGameLab(true,gold,func);
            this.updateChips(this.seatData.coin_balance);
            if (this.isWinner) {
                this.viewBase.setAllInNode(true);
                JdHelp.delay(this.viewBase.clickNode,()=>{
                    this.viewBase.setAllInNode(false);
                },1.2) 
            }
        });
    }

    //ui 操作
    //设置金币数
    updateChips(gold:number){
        let avatar = this.getAvatar();
        if (avatar) {
            avatar.refreshCoinBalance(gold);
        }
        let data = this.seatData;
        
        if (data) {
            
            let isUpdate = data.state == JdConst.SeatState.fold
                            || data.state == JdConst.SeatState.NoFight
                            || this.beloneTable.gameState() == JdConst.GameState.GameSettle
            if (this.isMySelf) {
                this.beloneTable.updateAddBet(data.coin_balance <= 0 && isUpdate);
            }
        }
    }

    //设置下注额
    setBetNumb(bet:number){
        bet = JdHelp.getRightMount(bet);
        this.viewBase.setBetNumb(bet);
    }

    setSmallCard(isShow:boolean){
        this.viewBase.seatComponent.smallPoker.opacity = isShow?255:0;
    }

    checkIsBet(){
        if (this.seatData) {
            return this.seatData.bet > 0
        }
        return false;
    }

    moveTo(pos:cc.Vec2,time:number,comp?:Function){
        let node = this.viewBase.seatNode;
        node.stopAllActions();
        JdHelp.moveToAction(node,pos,time,comp);
    }
    
    registerOperator(){
        this.setStateFunc(JdConst.SeatState.allin,this.allInOperatoar);
        this.setStateFunc(JdConst.SeatState.fold,this.foldOperator);
        this.setStateFunc(JdConst.SeatState.follow,this.followOperator);
        this.setStateFunc(JdConst.SeatState.pass,this.passOperator);
        this.setStateFunc(JdConst.SeatState.promote,this.promoteOperator);
        this.setStateFunc(JdConst.SeatState.NoFight,this.noOperator);
        this.setStateFunc(JdConst.SeatState.bet,this.betOperator);
    }

    //用户头像框的刷新
    onUserActive(){
        if (this.seatData) {
            this.viewBase.updatePoker(this.seatData.player_id);
            let avatar = this.getAvatar();
            if (!avatar) {
                avatar = this.beloneTable.tableView.addAvatarById(this.seatData.seat_id,this.seatData.player_id,this.viewBase.avatarNode);
            }
            this.setActiveInfo(true);
            avatar.show(true,this.seatData.player_id);
            avatar.showMask(true);
            avatar.refreshName(this.seatData.name);
            avatar.showCoinBalance(true);
            avatar.refreshCoinBalance(this.seatData.coin_balance);
            let self = this;
            avatar.setClickAvatarBtnListener(function () {
                Utility.playButtonSound()                
                self.showChat();
            })
        }
    }

    updatePoker(uid:number){
        this.viewBase.updatePoker(uid)
    }

    getAvatar(){
        if (this.seatData) {
            return this.beloneTable.tableView.getAvatarById(this.seatData.seat_id);
        }
    }

    //玩家站起
    playerStandUp(){
        this.resetInfoNode();
        this.setActiveInfo(false);
        this.isSeat = false;
        let seatData = this.seatData;
        if (seatData) {
            if (seatData.state != 0) {
                if (this.beloneTable.isRole(seatData.player_id)) {
                    this.beloneTable.throwCardsAction();
                }else{
                    this.throwCard();
                }
            }
        }
        this.seatData = null;
    }

    //玩家坐下
    playerSitDown(){
        this.isSeat = true;
        this.initPlayerState();
        this.setActiveInfo(true);
        //请求名字
        let data = this.seatData;
        if (data) {
            //设置玩家名字
            this.setPlayerName();
            //头像获取
            UserDataManager.getData(data.player_id,(data:IUserData)=>{
                if (this.viewBase.seatNode && this.viewBase.seatNode.isValid
                    && this.seatData) {
                    this.seatData.name = data.name || '';
                    this.setPlayerName();
                    //this.viewBase.setPlayerInfo(data);
                }
            })
        }

        if (JdConst.isDebugMode) {
            if (!this.isMySelf) {
                //this.showHandDirector();
            }
        }
    }

    //更新玩家状态显示
    updatePlayerState(proto:Jd.IBetNotify,func?:Function){
        //更新
        let data = this.seatData;
        if (data) {
            this.updateTableBet(data.bet,true,func);
        }
        this.updateChips(proto.coinBalance);
        this.playerOperatorState(proto.state);
        if (proto.state == JdConst.SeatState.allin) {
            TexasSound.allinSound();
        }
    }   

    protected playerOperatorState(idx:number,isInit:boolean=false){
        if (this.stateFunc[idx]) {
            this.stateFunc[idx](isInit);
        }
    }

    protected setStateFunc(state:JdConst.SeatState,func:Function){
        this.stateFunc[state] = func.bind(this); 
    }
    //
    private promoteOperator(isInit:boolean){
        this.setMask(false);
        this.hideOpTimeState();
        //加注
        this.setOperatorDes('6',JdConst.OperatorType.Image_Op)
    }

    //过牌
    private passOperator(isInit:boolean){
        this.setMask(false);
        this.hideOpTimeState();
        cc.log('------------>>>>过牌')
        this.setOperatorDes('4',JdConst.OperatorType.Image_Op)
        JdSound.playCheck();//让牌
    }

    private followOperator(isInit:boolean){
        this.setMask(false);
        this.hideOpTimeState();
        this.setOperatorDes('5',JdConst.OperatorType.Image_Op)
    }

    //弃牌
    foldOperator(isInit:boolean){
        this.setOperatorDes('8',JdConst.OperatorType.Image_Op)
        this.hideOpTimeState();
        this.setSmallCard(false);
        this.setMask(true);
        if (!isInit) {
            JdSound.playFold()//弃牌
            JdHelp.delay(this.viewBase.seatComponent.mask,()=>{
                cc.log('---->>>弃牌发送')
                if (this.operatorFunc) {
                    this.operatorFunc();
                }
            },0.7)
            this.throwCard();
            if (this.isMySelf) {
                this.beloneTable.maskHands();
            }
        }
    }

    //下底注
    private betOperator(isInit:boolean){
        this.hideOpTimeState();
        this.setMask(false);
        //处于下底注
        if (this.seatData) {
            this.updateTableBet(this.seatData.bet,true);
        }
    }

    //无状态
    private noOperator(isInit:boolean){
        this.setMask(true);
        this.setSmallCard(false);
        this.hideOpTimeState();
        if (this.seatData) {
            this.setHandState(this.seatData.player_id,false);
        }
    }

    private allInOperatoar(isInit:boolean){
        this.setMask(false);
        this.hideOpTimeState();
        //this.viewBase.setAllInNode(true);
        this.setOperatorDes('7',JdConst.OperatorType.Anim_Op);
    }

    setPlayerName(){
        this.setOperatorDes(this.seatData.name,JdConst.OperatorType.Name_Op);
    }

    //每轮结束调用，结束不需要
    roundOver(){
        this.hideOpTimeState()
        let data = this.seatData;
        if (data) {
            if (data.state == JdConst.SeatState.fold) {
                    //这些状态无需更改显示
            }else{
                this.setOperatorDes(data.name,JdConst.OperatorType.Name_Op)
            }
            data.bet = 0;//下注为零
        }
    }


    hideOpTimeState(){
        this.viewBase.cancleSlider();
        this.viewBase.hideOpTimeState();
    }

    //设置玩家状态
    initPlayerState(){
        let data = this.seatData;
        if (!data) {
            return;
        }
        let state = data.state;
        this.viewBase.colorSlider.hide();
        this.setMask(false);

        this.setSmallCard(!this.beloneTable.isRole(data.player_id))//控制small

        this.resumHands()

        this.updateChips(data.coin_balance);
        this.playerOperatorState(state,true)
    }

    //设置操作时间
    setOpTime(time:number,totalTime:number){
        if (time < 0) {
            return;
        }
        if (this.seatData) {
            let isPlayer = this.beloneTable.isRole(this.seatData.player_id);
            this.viewBase.setOpTime(time,totalTime,isPlayer);
        }
    }

    updateSeatInfo(seatConfig:JdSeatConfig){
        let ui = this.viewBase.seatComponent;
        if (ui) {
            ui.updateSeatInfo(seatConfig);
            this.setDebugPos(seatConfig.bubblepos);
        }
    }

    //直接显示牌值
    showHandDirector(){
        let data = this.seatData;
        if (data) {
            let cards = data.cards;
            if (cards && cards.length >= 2) {
                if (cards[0] > 0) {
                    this.viewBase.showHands(true);
                    for (let i = 0; i < 2; i++) {
                        let hand = this.playerHands[i];
                        hand.reset();
                        hand.code = cards[i];
                        hand.showCardOnly();
                    }
                }
            }
        }
    }

    //最后亮牌
    showEndHands(cards:number[],type:number,point:number){
        //亮牌的时候
        this.viewBase.cancleSlider()
        this.viewBase.hideOpTimeState();
        for (let del of this.playerHands) {
            del.hide();
        }

        for (let del of this.viewBase.dealCardsEffect) {
            del.reset()
        }

        this.viewBase.showHands(false);
        this.setSmallCard(false);
        this.setMask(false);
        if (!this.isMySelf && cards.length == 3 ) {//排除我方,3张牌才显示
            let sound = true;
            for (let i = 0; i < cards.length; i++) {
                let hand = this.playerHands[i];
                let smallCard = this.viewBase.smallCards[i];
                hand.reset();
                hand.code = cards[i];
                hand.showBack();
                let node = hand.node;
                node.stopAllActions();
                let cardPos = smallCard.parent.convertToWorldSpaceAR(smallCard.position);
                let localPos = node.parent.convertToNodeSpaceAR(cardPos);
                node.position = localPos;
                node.setScale(0.3,0.3);

                let time = JdConst.handsMoveTime;
                let moveTo = cc.moveTo(time,this.viewBase.pokerPos[i]);
                let scalTo = cc.scaleTo(time,JdConst.handsScalTo);
                node.angle = this.viewBase.pokerangle[i];
                let callFunc = cc.callFunc(()=>{
                    JdHelp.rotateActionEx(node,0.1,0.2,()=>{
                        if (sound) {
                            JdSound.playRotatePoker();
                            sound = false;
                        }
                        hand.showPoker();
                        if (type) {
                            this.showMaxPattern(type,point,!this.isWinner);
                        }
                    },null)
                })

                let spawn = cc.spawn(moveTo,scalTo);
                let seq1 = cc.sequence(spawn,callFunc);
                node.runAction(seq1);
            }
        }else{
            this.beloneTable.showCardsType();

            if (cards.length == 3) {
                //this.beloneTable.resumeHands(cards);
                for (let idx = 0; idx < cards.length; idx++) {
                    let hand = this.playerHands[idx];
                    hand.hide();
                    hand.code = cards[idx];
                    this.beloneTable.movePokers(idx,hand.node,()=>{
                        hand.showCardOnly();
                        if (type) {
                            this.showMaxPattern(type,point,!this.isWinner);
                        }
                    });
                }
            }
            this.beloneTable.showTypeNode(false);
        }
    }

    showMaxPattern(cardtype:number,cardPoint:number,isShowCardNode:boolean = true){
        if (cardtype > 6) {
            cc.error('错误的牌型:cardtype,cardPoint',cardtype,cardPoint);
            return;
        }
        let str = '0';
        if (cardtype == 1) {//牌型类型是单牌，看点数
            str = cardPoint.toString();
        }else{
            str = 'public_' + cardtype;
        }
        this.viewBase.showMaxCardType(str);
        this.viewBase.showMaxCardNode(isShowCardNode);
    }

    showMaxCardNode(isShow:boolean){
        let data = this.seatData;
        cc.log('-------->>>>>showMaxCardNode',data,isShow,this.isWinner)
        if (data && (data.state == 8 || data.state == 0)) {
            this.viewBase.showMaxCardNode(false);
        }else{
            this.viewBase.showMaxCardNode(isShow);
        }
    }

    //赢家动画
    showWinAnim(seatInfo:Jd.ISeatInfo,isFold:boolean,animEnd:Function){
        this.viewBase.showMaxCardNode(false);//飘分时需隐藏牌型类型
        //动画结束更新票分
        this.viewBase.showWinAnim(seatInfo,isFold,()=>{
            if (animEnd) {
                animEnd();
            }
        })
        
    }

    //延时显示动画
    delayShowWinAnim(seatInfo:Jd.ISeatInfo,isFold:boolean,animEnd:Function){
        JdHelp.delay(this.viewBase.betEndNode,()=>{
            this.showWinAnim(seatInfo,isFold,animEnd);
        },0.8)
    }

    isWinner :boolean = false;//是否是赢家
    //开始处理边池,必定有手牌
    startHandlSidePot(){
        this.hideOpTimeState();
        //隐藏动画
        //this.viewBase.isShowWinAnim(false);

        //重置手牌
        let data = this.seatData;
        if (data) {
            if (data.state != JdConst.SeatState.fold) {
                if (this.isMySelf) {
                    //this.beloneTable.showTwoHandsOnly(data.cards);
                }
            }  
        }
    }

    isShowWinAnim(isShow:boolean){
        this.viewBase.isShowWinAnim(isShow);
    }

    //开始游戏执行
    beginGame(protoData:Jd.IGameInfo){
        let data = this.seatData;
        if (!data) {
            return;
        }
        if (protoData.state == 2
            || protoData.state == 4) {
            if (protoData.currentSeat == data.seat_id) {
                this.setOpTime(protoData.stateExpiredTime-protoData.time,protoData.stateDuration);
            }
        }
        if (protoData.state != 0
            && protoData.state != 9) {
            if (this.isMySelf) {
                this.beloneTable.showHandCards(data.cards);
                this.beloneTable.setHandState(true);
                this.beloneTable.resumeHands(data.cards);
                if (protoData.state == JdConst.SeatState.fold) {
                    this.beloneTable.maskHands();
                }
                this.beloneTable.showCardsType();
                //this.showMaxPattern(data.card_type,data.card_point);
            }

            if(data.state == 7){
                this.setOperatorDes(data.state.toString(),JdConst.OperatorType.Anim_Op);
            }

            if (data.state != 2
                && data.state != 3
                && data.state != 0
                && data.state != 7) {
                this.setOperatorDes(data.state.toString(),JdConst.OperatorType.Image_Op);
            }

            this.resumHands();
            if (data.bet > 0) {
                this.updateTableBet(data.bet,false);
            }
        }
    }

    updateTableBet(numb:number,isShowAnim:boolean,func?:Function){
          //设置押注金额
        if (numb <= 0) {
            return;
        }
        this.setBetState(numb > 0);  
        if (isShowAnim) {
            this.checkBetAction(numb,func);
        }else{
            this.showBet(numb);
        }
    }

    //直接刷新牌值
    resumHands(){
        let data = this.seatData;
        this.viewBase.resetHands();
        if (this.isMySelf) {
            this.beloneTable.resetHands();
        }
        if (data && data.cards && data.cards.length > 0) {
            //设置手牌 
            if (this.isMySelf) {
                this.beloneTable.showHandCards(data.cards);
                this.beloneTable.setHandState(true);
                this.beloneTable.resumeHands(data.cards);
                if (data.state == JdConst.SeatState.fold) {
                    this.beloneTable.maskHands();
                }

            }else{
                this.resumeHands(data.cards);
            }
        }
    }


    //离开牌桌
    leaveGame(playerID:number){
       this.isSeat = false;
       if (this.seatData) {
        this.beloneTable.tableView.removeAvatarById(this.seatData.seat_id)
       }
       this.setHandState(playerID,false);
       this.seatData = null;
    }

    private setHandState(playerID:number,isShow:boolean){
        if (this.beloneTable.isRole(playerID)) {
            this.beloneTable.setHandState(isShow);
        }
    }

    private resetInfoNode(){
        this.hideOpTimeState();
        this.setSmallCard(false);
    }


    //游戏中重置,无需修改
    playingReset(){
        this.isSeat = false;
        cc.log('-->>>playingReset',false)
        this.isWinner = false;
        this.viewBase.playingReset();
        this.hideOpTimeState();
        this.hideCheckGold();
        this.setActiveInfo(false);
        this.seatData = null;
    }

    setDebugInfo(text:string){

        if (AppData.userConnectEnvi == 0) {
            this.viewBase.isShowDebugInfo(false,'')
            return;
        }

        let contents = JSON.parse(text);
        let getStr = (str:any)=>{
            if (typeof str == 'string' && str != '0') {
                return '-'
            }else{
                return Number(str).toFixed(2)
            }
        }

        let getPercent = (per1,per2)=>{
            if (typeof per1 == "number" && typeof per2 == 'number') {
                if (per2 == 0) {
                    return 0;
                }
                return (per1 / per2).toFixed(2);
            }
            return 0;
        }

        let str = '行为判断:' + contents[0] + '\n'
                + '最终胜率:' + getStr(contents[1]) + '\n'
                + '透视数目:' +  getStr(contents[2]) + '\n'
                + '理论最大加注:'+ getStr(contents[3])+'\n'
                + '加注调整百分比:'+ getStr(contents[4])+'\n'
                + '最终理论加注额:' + getStr(contents[5])+'\n'
                + '跟注盈利期望:' + getStr(contents[6]) + '\n'
                + '跟注亏损期望:' + getStr(contents[7]) + '\n'
                + '跟注盈亏比:'+getPercent(contents[6],contents[7])+'\n'

        this.viewBase.isShowDebugInfo(true,str)
    }

    setDebugPos(p:cc.Vec2){
        this.viewBase.setDebugPos(p)
    }

    //重置
    reset(){
        if (this.seatData) {
            this.setOperatorDes(this.seatData.name,JdConst.OperatorType.Name_Op);
            this.seatData.cards = [];
            this.seatData.card_point = 0;
            this.seatData.card_type = 0;
            this.seatData.state = 0;
        }
        this.isWinner = false;
        this.viewBase.reset();
        this.resumeHands([]);
        this.resetInfoNode();
        this.setSmallCard(false);
        this.setBetState(false);
    };

    clear(){
        this.reset();
        this.viewBase.clear();
    }

}
